import styled from '@emotion/styled';

export const TableStyled = styled.div`
  border: ${({ designTokens }) => `1px solid ${designTokens.podiumCdsColorGrey300}`};
  background: ${({ designTokens }) => `${designTokens.podiumCdsColorTextPrimaryInverse}`};
  min-width: ${({ fullWidth, scrollbarSize }) =>
    `${fullWidth ? `calc(100% - ${scrollbarSize}px) !important` : 'auto'}`};
  width: 100%;
  display: inline-block;

  .th {
    padding: 10px;
    background: ${({ designTokens }) => `${designTokens.podiumCdsColorGrey200}`};
    border-bottom: ${({ designTokens, noBorders }) =>
      noBorders ? 'none' : `1px solid ${designTokens.podiumCdsColorGrey300}`};
    border-right: ${({ designTokens, noBorders }) =>
      noBorders ? 'none' : `1px solid ${designTokens.podiumCdsColorGrey300}`};
  }

  .tbody {
    overflow-y: overlay;
  }

  .td {
    padding: 10px;
    display: flex;
    align-items: center;
    background: ${({ designTokens }) => `${designTokens.podiumCdsColorTextPrimaryInverse}`};
    border-bottom: ${({ designTokens, noBorders }) =>
      noBorders ? 'none' : `1px solid ${designTokens.podiumCdsColorGrey300}`};
    border-right: ${({ designTokens, noBorders }) =>
      noBorders ? 'none' : `1px solid ${designTokens.podiumCdsColorGrey300}`};
  }

  .tr {
    .td:last-child,
    .th:last-child {
      border-right: 0;
    }
  }
`;
